import React, { useState } from 'react';
import { ReactComponent as HomeAbstract } from '../../Assets/Images/homeabstract.svg';
import { ReactComponent as HomeMobileAbstract } from '../../Assets/Images/homemobileabstract.svg';
import Tabs from '../Tab/homeTab';
import { ArrowDown2 } from 'iconsax-react';
import { BuyIcon } from '../../Assets/Icons/buyIcon';
import { CoOwnIcon } from '../../Assets/Icons/coOwnIcon';
import { RentIcon } from '../../Assets/Icons/rentIcon';
import { useNavigate } from 'react-router-dom';


function Homepage() {
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const navigate = useNavigate();
  const tabs = [
    { id: 'rent', label: 'Rent', icon: RentIcon },
    { id: 'buy', label: 'Buy', icon: BuyIcon },
    { id: 'coOwn', label: 'Co-own', icon: CoOwnIcon },
  ];
  const handleTabChange = (index: number) => {
    console.log(index);
    setActiveTabIndex(index);
    console.log(`Selected Tab: ${tabs[index].id}`);
    const tabLabel = tabs[index].id;
    console.log(`Selected Tab: ${tabLabel}`);
  };


  const handleTabSelected = () => {
    navigate('/property');
  };
  return (
    <div>
      <div className='relative'>
        <div className='w-full hidden md:flex'>
          <HomeAbstract className='abstract' />
        </div>
        <div className='w-full md:hidden'>
          <HomeMobileAbstract className='abstract' style={{ width:'100%', height:'100%' }} />
        </div>
        <div className='absolute top-5 md:absolute md:top-16 flex flex-col items-center justify-center w-full '>
          <div
            className='flex flex-col justify-center items-center w-10/12 xl:w-1/2 lg:w-1/2 mx-auto lg:py-0 py-8 text-center '>
            <div className='w-full gap-4 flex mt-3.5'>
              <div className={'w-full'}>
                <Tabs tabs={tabs} activeTabIndex={activeTabIndex} onTabChange={handleTabChange} />
                <div className=" w-full">
                  <div className="">
                    {activeTabIndex === 0 ?
                      <div className={'bg-white rounded-b searchBoxShadow'}>
                        <div className={'flex flex-wrap gap-1 gap-y-2.5 justify-center lg:justify-around items-center p-4'}>
                          <div className={'w-[45%] lg:w-[30%] flex justify-between'}>
                            <div className={''}>
                              <label className={'block text-start text-xs lg:text-sm'}>Location</label>
                              <input type="text" placeholder={'Lagos,Nigeria'}
                                     className={'py-2 block w-full focus-visible:outline-0 md:text-sm text-xs'} />
                            </div>
                            <span className={'h-7 bg-custom-grey w-[0.1%] mx-6'}></span>
                          </div>
                          <div className={'w-[45%] lg:w-[30%] flex justify-between'}>
                            <div className={''}>
                              <label className={'block text-start text-xs lg:text-sm'}>Property Type</label>
                              <div className="relative">
                                <select
                                  className="appearance-none py-2 focus-visible:outline-0 rounded w-full pr-10 md:text-sm text-xs">
                                  <option value="" disabled selected>Select Property Type</option>
                                  <option>rent</option>
                                  <option>Co Own</option>
                                  <option>Buy</option>
                                </select>
                                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center">
                                  <ArrowDown2
                                    size="20"
                                    color="#CED4DA"
                                    variant="Bold"
                                  />
                                </div>
                              </div>
                            </div>
                            <span className={'h-7 bg-custom-grey w-[0.1%] mx-6'}></span>
                          </div>
                          <div className={'w-full lg:w-[30%]'}>
                            <button onClick={handleTabSelected}
                                    className="rounded-custom text-white bg-custom-darkgreen border font-semibold py-2 px-2.5 md:py-3.5 md:px-5">
                              Browse Properties
                            </button>
                          </div>
                        </div>
                      </div>
                      : activeTabIndex === 1 ?
                        <div className={'bg-white rounded-b searchBoxShadow'}>
                          <div className={'flex flex-wrap gap-1 gap-y-2.5 justify-center lg:justify-around items-center p-4'}>
                            <div className={'w-[45%] lg:w-[30%] flex justify-between'}>
                              <div className={''}>
                                <label className={'block text-start text-xs lg:text-sm'}>Location</label>
                                <input type="text" placeholder={'Lagos,Nigeria'}
                                       className={'py-2 block w-full focus-visible:outline-0 md:text-sm text-xs'} />
                              </div>
                              <span className={'h-7 bg-custom-grey w-[0.1%] mx-6'}></span>
                            </div>
                            <div className={'w-[45%] lg:w-[30%] flex justify-between'}>
                              <div className={''}>
                                <label className={'block text-start text-xs lg:text-sm'}>Property Type</label>
                                <div className="relative">
                                  <select
                                    className="appearance-none py-2 focus-visible:outline-0 rounded w-full pr-10 md:text-sm text-xs">
                                    <option value="" disabled selected>Select Property Type</option>
                                    <option>rent</option>
                                    <option>Co Own</option>
                                    <option>Buy</option>
                                  </select>
                                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center">
                                    <ArrowDown2
                                      size="20"
                                      color="#CED4DA"
                                      variant="Bold"
                                    />
                                  </div>
                                </div>
                              </div>
                              <span className={'h-7 bg-custom-grey w-[0.1%] mx-6'}></span>
                            </div>
                            <div className={'w-full lg:w-[30%]'}>
                              <button onClick={handleTabSelected}
                                      className="rounded-custom text-white bg-custom-darkgreen border font-semibold py-2 px-2.5 md:py-3.5 md:px-5">
                                Browse Properties
                              </button>
                            </div>
                          </div>
                        </div>
                        : activeTabIndex === 2 ?
                          <div className={'bg-white rounded-b searchBoxShadow'}>
                            <div className={'flex flex-wrap gap-1 gap-y-2.5 justify-center lg:justify-around items-center p-4'}>
                              <div className={'w-[45%] lg:w-[30%] flex justify-between'}>
                                <div className={''}>
                                  <label className={'block text-start text-xs lg:text-sm'}>Location</label>
                                  <input type="text" placeholder={'Lagos,Nigeria'}
                                         className={'py-2 block w-full focus-visible:outline-0 md:text-sm text-xs'} />
                                </div>
                                <span className={'h-7 bg-custom-grey w-[0.1%] mx-6'}></span>
                              </div>
                              <div className={'w-[45%] lg:w-[30%] flex justify-between'}>
                                <div className={''}>
                                  <label className={'block text-start text-xs lg:text-sm'}>Property Type</label>
                                  <div className="relative">
                                    <select
                                      className="appearance-none py-2 focus-visible:outline-0 rounded w-full pr-10 md:text-sm text-xs">
                                      <option value="" disabled selected>Select Property Type</option>
                                      <option>rent</option>
                                      <option>Co Own</option>
                                      <option>Buy</option>
                                    </select>
                                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center">
                                      <ArrowDown2
                                        size="20"
                                        color="#CED4DA"
                                        variant="Bold"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <span className={'h-7 bg-custom-grey w-[0.1%] mx-6'}></span>
                              </div>
                              <div className={'w-full lg:w-[30%]'}>
                                <button onClick={handleTabSelected}
                                        className="rounded-custom text-white bg-custom-darkgreen border font-semibold py-2 px-2.5 md:py-3.5 md:px-5">
                                  Browse Properties
                                </button>
                              </div>
                            </div>
                          </div>
                          : null
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}

export default Homepage;
